import { Component, OnInit } from '@angular/core';
import { LoopBackConfig } from "../../shared/sdk/index";
import { BASE_URL, API_VERSION } from "../../shared/base.url";
import { User, AccessToken } from "../../shared/sdk/models";
import { UserApi } from "../../shared/sdk/services";
import { Router } from "@angular/router";
import {
  AbstractControl,
  FormGroup,
  FormBuilder,
  Validators
} from "@angular/forms";

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})
export class SignUpComponent implements OnInit {
  loading: boolean;
  hide: boolean;
  error;
  user: User;
  signUpForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private userApi: UserApi,
    private router: Router
  ) {
    this.hide = true;
    LoopBackConfig.setBaseURL(BASE_URL);
    LoopBackConfig.setApiVersion(API_VERSION);
  }

  ngOnInit() {
    if (this.userApi.isAuthenticated()) {
      this.router.navigate([""]);
    }
    this.signUpForm = this.fb.group({
      emailFG: this.fb.group(
        {
          emailFC: [null, [Validators.required, Validators.email]],
          emailFCConfirm: [null, [Validators.required, Validators.email]]
        },
        { validator: this.emailMatch }
      ),
      passwordFG: this.fb.group(
        {
          passFC: [null, Validators.required],
          passFCConfirm: [null, [Validators.required]]
        },
        { validator: this.passwordMatch }
      )
    });
  }
  emailMatch(c: AbstractControl) {
    return c.get("emailFC").value === c.get("emailFCConfirm").value
      ? null
      : { noMatch: true };
  }
  passwordMatch(c: AbstractControl) {
    return c.get("passFC").value === c.get("passFCConfirm").value
      ? null
      : { noMatch: true };
  }
  onSubmit() {
    if (this.signUpForm.valid) {
      this.loading = true;
      this.user = new User({
        email: this.signUpForm.value.emailFG.emailFC,
        password: this.signUpForm.value.passwordFG.passFC
      });
      this.userApi.create(this.user).subscribe(
        (user: User) => {
          this.userApi.login(this.user).subscribe((token: AccessToken) => {
            this.router.navigate([""]);
          });
        },
        err => {
          this.error = err;
          this.loading = false;
        }
      );
    }else{
      console.log('error');
    }
  }

}
